/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsMainBarTitle_goal = {
    readonly readableId: number;
    readonly type: GoalType;
    readonly title: string;
    readonly " $refType": "GoalDetailsMainBarTitle_goal";
};
export type GoalDetailsMainBarTitle_goal$data = GoalDetailsMainBarTitle_goal;
export type GoalDetailsMainBarTitle_goal$key = {
    readonly " $data"?: GoalDetailsMainBarTitle_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsMainBarTitle_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsMainBarTitle_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readableId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '659254c2f7429772ccfb78d26db69651';
export default node;
